export default "__VITE_ASSET__1a9ab28c__"